import React from "react";
import { connect } from "react-redux";
import { Field, FieldArray, reduxForm, formValueSelector } from "redux-form";
import _ from "lodash";
import moment from "moment";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import reactCSS from "reactcss";
import draftToHtml from "draftjs-to-html";
import { format, addDays, parse } from "date-fns";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { jsPDF } from "jspdf";
import {
  addScheduleSession,
  updateScheduleSession,
  addAdditionalSpeaker,
  deleteAdditionalSpeaker,
  updateAdditionalSpeaker,
  addAdditionalSpeakerAssociation,
  addMultipleScheduleSession,
  openSessionModal,
  clearSingleSessionAssociatedUsers,
  clearSingleSessionRSVPUsers,
  openTrackModal,
  deleteAdditionalSpeakerBySession,
  fetchAndRefreshScheduleData,
  openPrivateSessionUserModal,
  addAssociatedUsers,
  updatePrivateAssociateUsers,
  addRsvpUsers,
  updateRSVPUsers,
  updateSessionFiles,
  updateSpeakerAssociate,
  selectScheduleDate,
  downloadSessionPdf,
  fetchSessionQr,
} from "ContentActions";
import { checkContentDashboardStatus } from "GeneralTabAction";
import {
  fetchUsersCategory,
  sortUserByCategory,
  editDashboardUser,
} from "DashboardUserAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { isEmpty } from "BaseFunctions";
import {
  COMMON_FAIL_MESSAGE,
  DATE_FORMAT_WITH_TIME,
  BASE_IMAGES_URL,
  validateUrl,
  MAIN_URL,
  DOMAIN_NAME,
  DEVELOPMENT_TYPE,
  maxLengthObjectFc,
  DISPLAY_LOCAL_DATE_FORMAT,
} from "Constants";
import SessionPrivateUserModal from "./session-private-user-modal";
import AllFilesDrop from "./file-drop";
// import AllFilesDrop from "AllFilesDrop";
import LocaleStrings from "Languages";
import ImageCropper from "ImageCropper";
import Loader from "Loader";
var MAXLENOBJ = {};

class AddTrackSession extends BaseComponent {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    this.state = {
      imagePreviewUrl: "",
      loading: false,
      additionalSpeakers: [],
      preventSubmit: false,
      privateSessionUsers: [],
      privateSessionUsersUpdated: false,
      rsvpSessionUsers: [],
      rsvpSessionUsersUpdated: false,
      loadingUserModalButton: "",
      isChangedCapacity: false,
      hideCapacityInputBox: true,
      isFileChanged: false,
      expendAdditionalSetting: DEVELOPMENT_TYPE === "koachify" ? true : false,
      isChangedEventifymeet: false,
      hideSessionMainVideo: false,
      userInterest: [],
      displayColorPicker: false,
      update: true, // Dont remove this code [Its to update the dom]
      QrDownloadLoading: false,
    };
    this.sessionType = "";
    this.sessionTypeAdded = false;
  }

  componentWillReceiveProps() {
    this.setState({ preventSubmit: false });
  }
  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history);

    if (
      this.props.appsession.eventid == 1781575476109723 ||
      this.props.appsession.eventid == 1781255125815482
    ) {
      MAXLENOBJ.title = 130;
    }
  }

  componentWillUnmount() {
    this.setState({ update: true });
  }

  open = () => {
    var { backgroundcolor } = this.props.sessionColors
      ? _.shuffle(this.props.sessionColors)[0]
      : { backgroundcolor: "#FDAFBD" };

    this.props.openSessionModal({
      status: true,
      otherdata: { backgroundcolor: backgroundcolor },
      session: {},
    });
    this.props.reset();
    this.clearData();
    this.props.editDashboardUser({});
  };

  close = () => {
    var files = [
      { position: "file1", file: "", filename: "" },
      { position: "file2", file: "", filename: "" },
      { position: "file3", file: "", filename: "" },
      { position: "file4", file: "", filename: "" },
      { position: "file5", file: "", filename: "" },
    ];

    this.props.updateSessionFiles(files); // store files details locally
    this.props.openSessionModal({ status: false, session: {} });
    this.props.clearSingleSessionAssociatedUsers();
    this.props.clearSingleSessionRSVPUsers();
    this.clearData();
    this.props.updateSpeakerAssociate([]);
  };

  clearData = () => {
    this.setState({
      loaded: false,
      preventSubmit: false,
      privateSessionUsers: [],
      privateSessionUsersUpdated: false,
      rsvpSessionUsers: [],
      rsvpSessionUsersUpdated: false,
      isChangedCapacity: false,
      hideCapacityInputBox: true,
      isFileChanged: false,
      expendAdditionalSetting: DEVELOPMENT_TYPE === "koachify" ? true : false,
      imagePreviewUrl: "",
      hideSessionMainVideo: false,
      isChangedEventifymeet: false,
    });
    this.sessionType = "";
    this.sessionTypeAdded = false;
  };

  onFormSubmit = (values) => {
    var {
      sessionfilesList,
      userCategoryList,
      settingData,
      initialValues,
      tracks,
      toEdit,
      selectedScheduleDate,
    } = this.props;

    // console.log("values....", values);
    // console.log("initialValues....", initialValues);

    values.location = values.location
      ? values.location.trim()
      : values.location;
    values.title = values.title.trim();

    // Check if no track option activated, then add no track default id logic start //
    let tracksForSelectedDate =
      selectedScheduleDate.ScheduleDateToScheduletracks
        ? selectedScheduleDate.ScheduleDateToScheduletracks
        : [];
    // console.log("tracksForSelectedDate :- ", tracksForSelectedDate);

    // Check for selected date track required or not
    let checkTrackStatus = _.filter(tracksForSelectedDate, (o) => {
      return o.trackname === "##NOTRACK##";
    });
    // console.log("checkTrackStatus :- ", checkTrackStatus);
    if (checkTrackStatus.length > 0) {
      values.scheduletrackid = checkTrackStatus[0]["scheduletrackid"];
    }
    // Check if no track option activated, then add no track default id logic end //

    if (this.state.preventSubmit) return; // This is a hack to prevent submit when user Add Track
    // Reconstruct start and end time to proper date format with selected date

    // Check selected track is under selected date or not
    let checkTrack = _.filter(tracks, (o) => {
      return o.value == values.scheduletrackid;
    });

    if (
      !values.scheduletrackid ||
      _.isEmpty(values.scheduletrackid.toString()) ||
      values.scheduletrackid === "-1" ||
      checkTrack.length === 0
    ) {
      this.props.showError(LocaleStrings.schedule_validation_track_required);
      return;
    }

    if (!_.isEmpty(values.tags)) {
      if (typeof values.tags === "string") {
        var allTags = values.tags;
      } else {
        let valueTags = [];
        values.tags.map((val, key) => {
          let obj = val;
          valueTags.push(obj);
        });
        var allTags = valueTags.join(",");
      }
      values["tags"] = allTags;
    }
    // Below code is commented by Vinay on 26-02-2020 as now we are using tinymce editor to save description and in tinymce this code does not required.

    // if(values.description && values.description.blocks){
    //   var html=draftToHtml(values.description);
    //   html=html.replace(/[\n\r]+/g, '');
    //   if(html == '<p></p>')
    //     html = '';

    //   values = {...values,description:html};
    // }

    // Color for session
    var { colorid } = _.filter(this.props.sessionColors, (color) => {
      return color.backgroundcolor == values.selectedcolor.toUpperCase();
    })[0];

    // console.log("colorid :- ", colorid);

    if (values.speakerid === "") {
      values = { ...values, speakerid: "0" };
    }

    var starttime = values.starttime;
    var endtime = values.endtime;

    // '-' removed from zoomid if any.
    if (values && values.videolink && values.videolink != "") {
      var videourl = validateUrl(values.videolink);
      if (videourl === false) {
        values.videolink = values.videolink.replace(/-/g, "");
      }
    }

    // Assigning eventifymeet if admin want to use
    if (values.iseventifyframe) {
      values.videolink = "https://sg0.live.eventify.io/";
    }

    for (var i = 1; i <= 4; i++) {
      var additionalvideo = values["additionalvideo" + i];

      if (additionalvideo && additionalvideo != "") {
        var additionalvideourl = validateUrl(values["additionalvideo" + i]);
        if (additionalvideourl === false) {
          values["additionalvideo" + i] = values["additionalvideo" + i].replace(
            /-/g,
            ""
          );
        }
      }
    }

    if (typeof starttime == "object") {
      var stime = moment(starttime).format("H:m");
      starttime = `${this.props.selectedScheduleDate.scheduledate} ${stime}`;
    } else {
      if (_.split(starttime, ":").length == 2) {
        starttime = `${this.props.selectedScheduleDate.scheduledate} ${starttime}`;
      }
    }
    if (typeof endtime == "object") {
      var etime = moment(endtime).format("H:m");
      endtime = `${this.props.selectedScheduleDate.scheduledate} ${etime}`;
    } else {
      if (_.split(endtime, ":").length == 2) {
        endtime = `${this.props.selectedScheduleDate.scheduledate} ${endtime}`;
      }
    }
    // console.log("starttime : - ", starttime);
    // console.log("endtime : - ", endtime);

    let additionalSpeakersArray = values.additionalspeakers;
    const additionalspeakers = [];
    if (additionalSpeakersArray && additionalSpeakersArray.length > 0) {
      additionalSpeakersArray.map((item, index) => {
        if (!_.isEmpty(item)) additionalspeakers.push(item);
      });
    }
    values.additionalspeakers = additionalspeakers;

    // Checking session capacity here
    if (values.unlimitedcapacity === true) {
      values.capacity = 0;
    } else {
      values.capacity = values.capacity;
    }

    // Ticket associated with session type
    let ticketAsso = values.ticketassociated;
    var res = null;

    if (
      ticketAsso &&
      ticketAsso != "" &&
      Array.isArray(ticketAsso) &&
      ticketAsso.length > 0
    ) {
      res = ticketAsso.join(",");
    } else if (ticketAsso && ticketAsso != "" && !Array.isArray(ticketAsso)) {
      res = ticketAsso;
    } else {
      res = null;
    }

    values.sessionPrivateUsers = this.state.privateSessionUsers;
    values.sessionRSVPUsers = this.state.rsvpSessionUsers;

    if (
      values.unlimitedcapacity == false &&
      values.capacity < values.sessionRSVPUsers.length
    ) {
      this.props.showError(LocaleStrings.schedule_rsvp_capacity_exceed);
    }

    values.ticketassociated = res;
    if (
      values.sessiontype != "additional" &&
      values.sessiontype != "addprivate"
    ) {
      values.ticketassociated = null;
    }

    var attendee = _.filter(userCategoryList.data, (obj) => {
      return obj.type == "attendee";
    });
    var cat = attendee[0].id;
    values.usercategory = cat;
    values.formid = settingData.resource[0].eventformid;

    if (
      values.unlimitedcapacity == false &&
      values.capacity < values.sessionPrivateUsers.length
    ) {
      this.props.showError(LocaleStrings.schedule_capacity_exceed);
      return false;
    } else if (
      values.unlimitedcapacity == false &&
      values.capacity < initialValues.selectedAppusers.length
    ) {
      this.props.showError(LocaleStrings.schedule_capacity_exceed);
      return false;
    }

    var newusers = [];
    var deleteusers = [];
    if (toEdit && this.state.privateSessionUsersUpdated == true) {
      let addUserToPrivate = values.sessionPrivateUsers.filter(
        (o1) =>
          !initialValues.sessionAssocUsers.some(
            (o2) => o1.appuserid === o2.appuserid
          )
      );
      let deleteUserFromPrivate = initialValues.sessionAssocUsers.filter(
        (o1) =>
          !values.sessionPrivateUsers.some(
            (o2) => o1.appuserid === o2.appuserid
          )
      );
      // console.log("new :- ", addUserToPrivate);
      // console.log("del :- ", deleteUserFromPrivate);

      addUserToPrivate.map((user) => {
        newusers.push({
          appuserid: user.appuserid,
          eventid: values.eventid,
          sessionid: values.sessionid,
        });
      });

      deleteUserFromPrivate.map((user) => {
        deleteusers.push({
          id: user.id,
        });
      });
    }
    // console.log("newusers :- ", newusers);
    // console.log("deleteusers :- ", deleteusers);

    var newrsvpusers = [];
    var deletersvpusers = [];
    if (toEdit && this.state.rsvpSessionUsersUpdated == true) {
      let addUserToRSVP = values.sessionRSVPUsers.filter(
        (o1) =>
          !initialValues.sessionAssocRSVPUsers.some(
            (o2) => o1.appuserid === o2.appuserid
          )
      );
      let deleteUserFromRSVP = initialValues.sessionAssocRSVPUsers.filter(
        (o1) =>
          !values.sessionRSVPUsers.some((o2) => o1.appuserid === o2.appuserid)
      );
      // console.log("addUserToRSVP: new :- ", addUserToRSVP);
      // console.log("addUserToRSVP del :- ", deleteUserFromRSVP);

      addUserToRSVP.map((user) => {
        newrsvpusers.push({
          appuserid: user.appuserid,
          eventid: values.eventid,
          sessionid: values.sessionid,
        });
      });

      deleteUserFromRSVP.map((user) => {
        deletersvpusers.push({
          id: user.id,
        });
      });
    }
    // console.log("newrsvpusers :- ", newrsvpusers);
    // console.log("deletersvpusers :- ", deletersvpusers);

    if (
      (!values.sendpush == "" || !values.sendpush == undefined) &&
      (values.pushmessage == "" || values.pushmessage == undefined)
    ) {
      this.props.showError(
        LocaleStrings.schedule_validation_push_message_required
      );
      return false;
    }

    if (values.sendpush === "") {
      values.pushmessage = "";
    }

    // console.log("Final values :- ", values);
    // console.log("initialValues ------------:- ", initialValues);

    // return false;

    this.setState({ loading: true });
    if (!this.props.toEdit) {
      // Add New Session

      var toRefresh = true;
      if (additionalspeakers) toRefresh = additionalspeakers.length === 0;
      if (values.scheduletrackid === "-100") {
        // This option is hide on 03_04_2020 by vinay, as it was not required too add same session to all tracks as per Hussain sir.
        // We need to add schedule of all the available tracks

        var mulitpleSessions = [];
        var singleSession = {
          ...values,
          starttime,
          endtime,
          colorid,
          scheduledateid: this.props.selectedScheduleDate.scheduledateid,
        };
        var availableTracks =
          this.props.selectedScheduleDate.ScheduleDateToScheduletracks;
        availableTracks.map((track) => {
          var session = {
            ...singleSession,
            scheduletrackid: track.scheduletrackid,
            eventid: this.props.appsession.eventid,
          };
          mulitpleSessions.push(session);
        });
        this.props.addMultipleScheduleSession(
          mulitpleSessions,
          sessionfilesList,
          this.props.appsession,
          toRefresh,
          (response) => {
            if (response.error) {
              this.props.showError(COMMON_FAIL_MESSAGE);
            } else {
              const sessionid = response.data.resource[0].sessionid;
              if (additionalspeakers && additionalspeakers.length > 0) {
                // If multiple speaker is available, then adding additional speakers with first session olny.

                var speakers = [];
                additionalspeakers.map((speaker) => {
                  speakers.push({
                    ...speaker,
                    eventid: this.props.appsession.eventid,
                    sessionid: sessionid,
                  });
                });
                this.props.addAdditionalSpeakerAssociation(
                  speakers,
                  this.props.appsession,
                  this.props.selectedScheduleDate.scheduledateid,
                  (response) => {
                    if (values.sessionRSVPUsers.length > 0) {
                      var users = [];
                      values.sessionRSVPUsers.map((user) => {
                        users.push({
                          appuserid: user.appuserid,
                          eventid: this.props.appsession.eventid,
                          sessionid: sessionid,
                        });
                      });

                      this.props.addRsvpUsers(
                        users,
                        this.props.appsession,
                        (responseRU) => {
                          if (values.sessionPrivateUsers.length > 0) {
                            var users = [];
                            values.sessionPrivateUsers.map((user) => {
                              users.push({
                                appuserid: user.appuserid,
                                eventid: this.props.appsession.eventid,
                                sessionid: sessionid,
                              });
                            });

                            this.props.addAssociatedUsers(
                              users,
                              this.props.appsession,
                              this.props.selectedScheduleDate.scheduledateid,
                              (responseAU) => {
                                this.setState({ loading: false });
                                this.props.reset();
                                this.close();
                                this.props.showSuccess(
                                  LocaleStrings.schedule_form_add_success
                                );
                              }
                            );
                          } else {
                            this.props.fetchAndRefreshScheduleData(
                              this.props.appsession,
                              this.props.selectedScheduleDate.scheduledateid
                            );
                            this.setState({ loading: false });
                            this.props.reset();
                            this.close();
                            this.props.showSuccess(
                              LocaleStrings.schedule_form_add_success
                            );
                          }
                        }
                      );
                    } else {
                      if (values.sessionPrivateUsers.length > 0) {
                        var users = [];
                        values.sessionPrivateUsers.map((user) => {
                          users.push({
                            appuserid: user.appuserid,
                            eventid: this.props.appsession.eventid,
                            sessionid: sessionid,
                          });
                        });

                        this.props.addAssociatedUsers(
                          users,
                          this.props.appsession,
                          this.props.selectedScheduleDate.scheduledateid,
                          (responseAU) => {
                            this.setState({ loading: false });
                            this.props.reset();
                            this.close();
                            this.props.showSuccess(
                              LocaleStrings.schedule_form_add_success
                            );
                          }
                        );
                      } else {
                        this.props.fetchAndRefreshScheduleData(
                          this.props.appsession,
                          this.props.selectedScheduleDate.scheduledateid
                        );
                        this.setState({ loading: false });
                        this.props.reset();
                        this.close();
                        this.props.showSuccess(
                          LocaleStrings.schedule_form_add_success
                        );
                      }
                    }
                  }
                );
              } else {
                if (values.sessionRSVPUsers.length > 0) {
                  var users = [];
                  values.sessionRSVPUsers.map((user) => {
                    users.push({
                      appuserid: user.appuserid,
                      eventid: this.props.appsession.eventid,
                      sessionid: sessionid,
                    });
                  });

                  this.props.addRsvpUsers(
                    users,
                    this.props.appsession,
                    (responseRU) => {
                      if (values.sessionPrivateUsers.length > 0) {
                        var users = [];
                        values.sessionPrivateUsers.map((user) => {
                          users.push({
                            appuserid: user.appuserid,
                            eventid: this.props.appsession.eventid,
                            sessionid: sessionid,
                          });
                        });

                        this.props.addAssociatedUsers(
                          users,
                          this.props.appsession,
                          this.props.selectedScheduleDate.scheduledateid,
                          (responseAU) => {
                            this.setState({ loading: false });
                            this.props.reset();
                            this.close();
                            this.props.showSuccess(
                              LocaleStrings.schedule_form_add_success
                            );
                          }
                        );
                      } else {
                        this.props.fetchAndRefreshScheduleData(
                          this.props.appsession,
                          this.props.selectedScheduleDate.scheduledateid
                        );
                        this.setState({ loading: false });
                        this.props.reset();
                        this.close();
                        this.props.showSuccess(
                          LocaleStrings.schedule_form_add_success
                        );
                      }
                    }
                  );
                } else {
                  if (values.sessionPrivateUsers.length > 0) {
                    var users = [];
                    values.sessionPrivateUsers.map((user) => {
                      users.push({
                        appuserid: user.appuserid,
                        eventid: this.props.appsession.eventid,
                        sessionid: sessionid,
                      });
                    });

                    this.props.addAssociatedUsers(
                      users,
                      this.props.appsession,
                      this.props.selectedScheduleDate.scheduledateid,
                      (responseAU) => {
                        this.setState({ loading: false });
                        this.props.reset();
                        this.close();
                        this.props.showSuccess(
                          LocaleStrings.schedule_form_add_success
                        );
                      }
                    );
                  } else {
                    this.props.fetchAndRefreshScheduleData(
                      this.props.appsession,
                      this.props.selectedScheduleDate.scheduledateid
                    );
                    this.setState({ loading: false });
                    this.props.reset();
                    this.close();
                    this.props.showSuccess(
                      LocaleStrings.schedule_form_add_success
                    );
                  }
                }
              }
            }
            this.props.checkContentDashboardStatus(this.props.appsession);
          }
        );
      } else {
        // Adding Single session

        values = {
          ...values,
          starttime,
          endtime,
          colorid,
          scheduledateid: this.props.selectedScheduleDate.scheduledateid,
        };

        this.props.addScheduleSession(
          values,
          sessionfilesList,
          this.props.appsession,
          toRefresh,
          (response) => {
            if (response.error) {
              this.props.showError(COMMON_FAIL_MESSAGE);
            } else if (response.error == 2) {
              this.props.showError("Session ticket is not created, Try again");
            } else if (response.error == 3) {
              this.props.showError("Session Banner is not uploaded, Try again");
            } else {
              const sessionid = response.data.resource[0].sessionid;
              if (additionalspeakers && additionalspeakers.length > 0) {
                // If multiple speaker.
                var speakers = [];
                additionalspeakers.map((speaker) => {
                  speakers.push({
                    ...speaker,
                    eventid: this.props.appsession.eventid,
                    sessionid: sessionid,
                  });
                });
                this.props.addAdditionalSpeakerAssociation(
                  speakers,
                  this.props.appsession,
                  this.props.selectedScheduleDate.scheduledateid,
                  (response) => {
                    if (values.sessionRSVPUsers.length > 0) {
                      var users = [];
                      values.sessionRSVPUsers.map((user) => {
                        users.push({
                          appuserid: user.appuserid,
                          eventid: this.props.appsession.eventid,
                          sessionid: sessionid,
                        });
                      });

                      this.props.addRsvpUsers(
                        users,
                        this.props.appsession,
                        (responseRU) => {
                          if (values.sessionPrivateUsers.length > 0) {
                            var users = [];
                            values.sessionPrivateUsers.map((user) => {
                              users.push({
                                appuserid: user.appuserid,
                                eventid: this.props.appsession.eventid,
                                sessionid: sessionid,
                              });
                            });

                            this.props.addAssociatedUsers(
                              users,
                              this.props.appsession,
                              this.props.selectedScheduleDate.scheduledateid,
                              (responseAU) => {
                                this.setState({ loading: false });
                                this.props.reset();
                                this.close();
                                this.props.showSuccess(
                                  LocaleStrings.schedule_form_add_success
                                );
                              }
                            );
                          } else {
                            this.props.fetchAndRefreshScheduleData(
                              this.props.appsession,
                              this.props.selectedScheduleDate.scheduledateid
                            );
                            this.setState({ loading: false });
                            this.props.reset();
                            this.close();
                            this.props.showSuccess(
                              LocaleStrings.schedule_form_add_success
                            );
                          }
                        }
                      );
                    } else {
                      if (values.sessionPrivateUsers.length > 0) {
                        var users = [];
                        values.sessionPrivateUsers.map((user) => {
                          users.push({
                            appuserid: user.appuserid,
                            eventid: this.props.appsession.eventid,
                            sessionid: sessionid,
                          });
                        });

                        this.props.addAssociatedUsers(
                          users,
                          this.props.appsession,
                          this.props.selectedScheduleDate.scheduledateid,
                          (responseAU) => {
                            this.setState({ loading: false });
                            this.props.reset();
                            this.close();
                            this.props.showSuccess(
                              LocaleStrings.schedule_form_add_success
                            );
                          }
                        );
                      } else {
                        this.props.fetchAndRefreshScheduleData(
                          this.props.appsession,
                          this.props.selectedScheduleDate.scheduledateid
                        );
                        this.setState({ loading: false });
                        this.props.reset();
                        this.close();
                        this.props.showSuccess(
                          LocaleStrings.schedule_form_add_success
                        );
                      }
                    }
                  }
                );
              } else {
                if (values.sessionRSVPUsers.length > 0) {
                  var users = [];
                  values.sessionRSVPUsers.map((user) => {
                    users.push({
                      appuserid: user.appuserid,
                      eventid: this.props.appsession.eventid,
                      sessionid: sessionid,
                    });
                  });

                  this.props.addRsvpUsers(
                    users,
                    this.props.appsession,

                    (responseRU) => {
                      if (values.sessionPrivateUsers.length > 0) {
                        var users = [];
                        values.sessionPrivateUsers.map((user) => {
                          users.push({
                            appuserid: user.appuserid,
                            eventid: this.props.appsession.eventid,
                            sessionid: sessionid,
                          });
                        });

                        this.props.addAssociatedUsers(
                          users,
                          this.props.appsession,
                          this.props.selectedScheduleDate.scheduledateid,
                          (responseAU) => {
                            this.setState({ loading: false });
                            this.props.reset();
                            this.close();
                            this.props.showSuccess(
                              LocaleStrings.schedule_form_add_success
                            );
                          }
                        );
                      } else {
                        this.props.fetchAndRefreshScheduleData(
                          this.props.appsession,
                          this.props.selectedScheduleDate.scheduledateid
                        );
                        this.setState({ loading: false });
                        this.props.reset();
                        this.close();
                        this.props.showSuccess(
                          LocaleStrings.schedule_form_add_success
                        );
                      }
                    }
                  );
                } else {
                  if (values.sessionPrivateUsers.length > 0) {
                    var users = [];
                    values.sessionPrivateUsers.map((user) => {
                      users.push({
                        appuserid: user.appuserid,
                        eventid: this.props.appsession.eventid,
                        sessionid: sessionid,
                      });
                    });

                    this.props.addAssociatedUsers(
                      users,
                      this.props.appsession,
                      this.props.selectedScheduleDate.scheduledateid,
                      (responseAU) => {
                        this.setState({ loading: false });
                        this.props.reset();
                        this.close();
                        this.props.showSuccess(
                          LocaleStrings.schedule_form_add_success
                        );
                      }
                    );
                  } else {
                    this.props.fetchAndRefreshScheduleData(
                      this.props.appsession,
                      this.props.selectedScheduleDate.scheduledateid
                    );
                    this.setState({ loading: false });
                    this.props.reset();
                    this.close();
                    this.props.showSuccess(
                      LocaleStrings.schedule_form_add_success
                    );
                  }
                }
              }
              this.props.checkContentDashboardStatus(this.props.appsession);
            }
          }
        );
      }
    } else {
      // Session edit section

      let sessionid = values.sessionid;
      let eventid = values.eventid;
      // var currentTime = new Date(moment().format("YYYY,MM,DD HH:mm:ss"));
      // var newcurrentTime = moment(currentTime).format("YYYY-MM-DD HH:mm:ss");
      values = {
        ...values,
        starttime,
        endtime,
        colorid,
        scheduledateid: this.props.selectedScheduleDate.scheduledateid,
      };
      delete values["ispushqueued"];
      let newDate = moment(moment(values.starttime).format("YYYY-MM-DD HH:mm"));
      if (
        newDate.isAfter(
          moment(moment(initialValues.starttimeold).format("YYYY-MM-DD HH:mm"))
        )
      ) {
        values.ispushqueued = 0;
      }
      // console.log("values", values);
      this.props.updateScheduleSession(
        values,
        sessionfilesList,
        this.props.appsession,
        (response) => {
          if (response.error) {
            this.props.showError(COMMON_FAIL_MESSAGE);
          } else if (response.error == 2) {
            this.props.showError("Session ticket is not updated, Try again");
          } else if (response.error == 3) {
            this.props.showError("Session Banner is not uploaded, Try again");
          } else {
            this.props.deleteAdditionalSpeakerBySession(
              sessionid,
              eventid,
              this.props.selectedScheduleDate.scheduledateid,
              this.props.appsession,
              (responseD) => {
                // console.log('responseD: - ', responseD)
                if (responseD.error) {
                  this.props.showError(
                    COMMON_FAIL_MESSAGE + " with delete query"
                  );
                } else {
                  // const sessionid=response.data.resource[0].sessionid;
                  if (additionalspeakers && additionalspeakers.length > 0) {
                    var speakers = [];
                    additionalspeakers.map((speaker) => {
                      speakers.push({
                        speakerid: speaker.speakerid,
                        eventid: eventid,
                        sessionid: sessionid,
                      });
                    });
                    this.props.addAdditionalSpeakerAssociation(
                      speakers,
                      this.props.appsession,
                      this.props.selectedScheduleDate.scheduledateid,
                      (responseI) => {
                        if (
                          newrsvpusers.length > 0 ||
                          deletersvpusers.length > 0
                        ) {
                          this.props.updateRSVPUsers(
                            newrsvpusers,
                            deletersvpusers,
                            this.props.appsession,
                            (responseRU) => {
                              // Check if session type is private and associated users changed, than delete the removed associated users and add new.
                              // if (
                              //   (values.sessiontype === "private" ||
                              //     values.sessiontype === "rsvp") &&
                              //   (newusers.length > 0 || deleteusers.length > 0)
                              // )
                              if (
                                newusers.length > 0 ||
                                deleteusers.length > 0
                              ) {
                                this.props.updatePrivateAssociateUsers(
                                  newusers,
                                  deleteusers,
                                  this.props.appsession,
                                  this.props.selectedScheduleDate
                                    .scheduledateid,
                                  (responseAU) => {
                                    this.setState({ loading: false });
                                    this.props.reset();
                                    this.close();
                                    this.props.showSuccess(
                                      LocaleStrings.schedule_form_update_success
                                    );
                                  }
                                );
                              } else {
                                this.props.fetchAndRefreshScheduleData(
                                  this.props.appsession,
                                  this.props.selectedScheduleDate.scheduledateid
                                );
                                this.setState({ loading: false });
                                this.props.reset();
                                this.close();
                                this.props.showSuccess(
                                  LocaleStrings.schedule_form_update_success
                                );
                              }
                            }
                          );
                        } else {
                          // Check if session type is private and associated users changed, than delete the removed associated users and add new.
                          // if (
                          //   (values.sessiontype === "private" ||
                          //     values.sessiontype === "rsvp") &&
                          //   (newusers.length > 0 || deleteusers.length > 0)
                          // )
                          if (newusers.length > 0 || deleteusers.length > 0) {
                            this.props.updatePrivateAssociateUsers(
                              newusers,
                              deleteusers,
                              this.props.appsession,
                              this.props.selectedScheduleDate.scheduledateid,
                              (responseAU) => {
                                this.setState({ loading: false });
                                this.props.reset();
                                this.close();
                                this.props.showSuccess(
                                  LocaleStrings.schedule_form_update_success
                                );
                              }
                            );
                          } else {
                            this.props.fetchAndRefreshScheduleData(
                              this.props.appsession,
                              this.props.selectedScheduleDate.scheduledateid
                            );
                            this.setState({ loading: false });
                            this.props.reset();
                            this.close();
                            this.props.showSuccess(
                              LocaleStrings.schedule_form_update_success
                            );
                          }
                        }
                      }
                    );
                  } else {
                    if (newrsvpusers.length > 0 || deletersvpusers.length > 0) {
                      this.props.updateRSVPUsers(
                        newrsvpusers,
                        deletersvpusers,
                        this.props.appsession,
                        (responseRU) => {
                          // Check if session type is private and associated users changed, than delete the removed associated users and add new.
                          // if (
                          //   (values.sessiontype === "private" ||
                          //     values.sessiontype === "rsvp") &&
                          //   (newusers.length > 0 || deleteusers.length > 0)
                          // )
                          if (newusers.length > 0 || deleteusers.length > 0) {
                            this.props.updatePrivateAssociateUsers(
                              newusers,
                              deleteusers,
                              this.props.appsession,
                              this.props.selectedScheduleDate.scheduledateid,
                              (responseAU) => {
                                this.setState({ loading: false });
                                this.props.reset();
                                this.close();
                                this.props.showSuccess(
                                  LocaleStrings.schedule_form_update_success
                                );
                              }
                            );
                          } else {
                            this.props.fetchAndRefreshScheduleData(
                              this.props.appsession,
                              this.props.selectedScheduleDate.scheduledateid
                            );
                            this.setState({ loading: false });
                            this.props.reset();
                            this.close();
                            this.props.showSuccess(
                              LocaleStrings.schedule_form_update_success
                            );
                          }
                        }
                      );
                    } else {
                      // Check if session type is private and associated users changed, than delete the removed associated users and add new.
                      if (newusers.length > 0 || deleteusers.length > 0) {
                        this.props.updatePrivateAssociateUsers(
                          newusers,
                          deleteusers,
                          this.props.appsession,
                          this.props.selectedScheduleDate.scheduledateid,
                          (responseAU) => {
                            this.setState({ loading: false });
                            this.props.reset();
                            this.close();
                            this.props.showSuccess(
                              LocaleStrings.schedule_form_update_success
                            );
                          }
                        );
                      } else {
                        this.props.fetchAndRefreshScheduleData(
                          this.props.appsession,
                          this.props.selectedScheduleDate.scheduledateid
                        );
                        this.setState({ loading: false });
                        this.props.reset();
                        this.close();
                        this.props.showSuccess(
                          LocaleStrings.schedule_form_update_success
                        );
                      }
                    }
                  }
                }
              }
            );
          }
        }
      );
    }
  };

  handleScheduleDate = (e) => {
    let d = e.target.value;
    let { dates } = this.props;

    let match = _.filter(dates, (o) => {
      return o.scheduledateid == d;
    });

    if (match.length > 0) {
      this.props.selectScheduleDate(match[0]);
    }
  };

  addNewTrack = (e) => {
    e.preventDefault();
    this.setState({ preventSubmit: true });
    this.close();
    this.props.openTrackModal(true);
  };

  addNewTrackForSessionWithNoCurrentTrack = (e) => {
    e.preventDefault();
    this.setState({ preventSubmit: true });
    //this.close();
    this.props.openTrackModal(true);
  };

  onImageSave = (img) => {
    this.setState({ imagePreviewUrl: img == "" ? "" : img });
    this.props.autofill("coverimagehidden", img);
  };

  onImageChange = (imageAvailable) => {};

  openPrivateUserModal = (type) => {
    this.setState({ loadingUserModalButton: type });

    // Fetching user categories and all admin users first time
    this.props.fetchUsersCategory(this.props.appsession, (response) => {
      var admins = _.filter(response.data, (obj) => {
        return obj.type === "attendee";
      });
      this.props.sortUserByCategory(
        this.props.appsession,
        admins[0].id,
        1,
        0,
        (callback) => {
          this.props.openPrivateSessionUserModal({ show: true, type: type });
          this.setState({ loadingUserModalButton: "" });
        }
      );
    });
  };

  handleAccoicatedUsers = (newusers) => {
    let { sessionPrivateUsersModal } = this.props;

    this.setState(
      sessionPrivateUsersModal.type === "private"
        ? {
            privateSessionUsers: newusers,
            privateSessionUsersUpdated: true,
          }
        : { rsvpSessionUsers: newusers, rsvpSessionUsersUpdated: true }
    );
  };

  handleCapacity = (e) => {
    var value = e.target.checked;

    this.props.autofill("capacity", "");
    this.setState({ hideCapacityInputBox: value, isChangedCapacity: true });
  };

  handleSessionTitle = (e) => {
    var value = e.target.value;
    let { sessiontitle, sendpush, pushmessage } = this.props;

    // console.log("value :- ", value);
    // console.log("sessiontitle :- ", sessiontitle);
    // console.log("Sendpush :- ", sendpush);
    // console.log("pushmessage :- ", pushmessage);

    if (
      value !== "" &&
      sendpush !== undefined &&
      sendpush !== "" &&
      (pushmessage === undefined ||
        pushmessage === "" ||
        pushmessage === null ||
        pushmessage === "Reminder for {session_name}" ||
        pushmessage === `Reminder for ${sessiontitle}`)
    ) {
      let text = `Reminder for ${value}`;
      this.props.autofill("pushmessage", text);
    } else if (value === "") {
      this.props.autofill("pushmessage", "Reminder for {session_name}");
    }
  };

  handlesendpush = (e) => {
    var value = e.target.value;
    let { sessiontitle, sendpush, pushmessage } = this.props;

    // console.log("value :- ", value);
    // console.log("sessiontitle :- ", sessiontitle);
    // console.log("Sendpush :- ", sendpush);
    // console.log("pushmessage :- ", pushmessage);

    if (
      value !== "" &&
      (pushmessage === undefined ||
        pushmessage === null ||
        pushmessage === "" ||
        pushmessage === "Reminder for {session_name}")
    ) {
      let text =
        sessiontitle === undefined || sessiontitle === ""
          ? "Reminder for {session_name}"
          : `Reminder for ${sessiontitle}`;
      this.props.autofill("pushmessage", text);
    } else if (value === "") {
      this.props.autofill("pushmessage", "");
    }
  };

  handleSessionType = (e) => {
    var sessiontype = e.target.value;

    this.sessionType = sessiontype;
    this.sessionTypeAdded = true;
    // Dont remove this code [Its to update the dom]
    this.setState({ update: !this.state.update });
  };

  otherFiles = () => {
    let { sessionfilesList } = this.props;

    return _.map(sessionfilesList, (item, index) => {
      // console.log('index :- ', index);
      var filePreview = "";
      var fileName = "";
      var fileOld = true;
      if (item && item.file) {
        var file = item.file;
        fileName = item.filename;
        filePreview = `${BASE_IMAGES_URL}/${file}?api_key=${this.props.appsession.apiKey}&session_token=${this.props.appsession.sessionToken}`;
        fileOld = true;
        var n = file.search(";base64,");
        if (n > 0) {
          fileOld = false;
        }
      }

      return (
        <div key={`${item.position}`} className="col-md-12 form-group">
          <AllFilesDrop
            onFileSave={this.onFilesDrop.bind(this, index)}
            onFileChnageLocally={this.onFileAvailable}
            filepath={filePreview}
            fileName={fileName}
            fileOld={fileOld}
            position={item.position}
            // className="content-files-dropbox"
            className="attachment-files-dropbox"
            insideText={
              <div className="h-100">
                <img
                  src={`../../style/images/upload_icon1.svg`}
                  style={{ width: 30, height: 30, margin: "0px 10px 0px" }}
                />
                <span className="">
                  Drag and Drop or Click here to upload file
                </span>
              </div>
            }
          />
        </div>
      );
    });
  };

  onFilesDrop = (index, files) => {
    let { sessionfilesList } = this.props;

    // console.log('files :- ', files)
    // console.log('index :- ', index)
    // console.log('sessionfilesList :- ', sessionfilesList)

    sessionfilesList[index].file = files.file ? files.file : "";
    sessionfilesList[index].filename = files.filename ? files.filename : "";

    // console.log('sessionfilesList : - ', sessionfilesList)
    this.props.updateSessionFiles(sessionfilesList);
  };

  onFileAvailable = (chnaged) => {
    this.setState({ isFileChanged: chnaged });
  };

  toggleStep(current) {
    // console.log("current", current);
    let currentStep = this.state[current];
    //console.log('currentStep',currentStep);
    this.setState({ [current]: !currentStep });
  }

  handleEventifyMeet = (e) => {
    var value = e.target.checked;
    var { toEdit, initialValues } = this.props;

    if (toEdit) {
      this.props.autofill("videolink", "");
      this.props.autofill("restrictstarttime1", false);

      if (value) {
        this.props.autofill(
          "restrictstarttime1",
          initialValues.restrictstarttime1
        );
      }
    }
    this.setState({ hideSessionMainVideo: value, isChangedEventifymeet: true });
  };

  handlePickerClose() {
    this.setState({ displayColorPicker: false });
  }

  handlePickerClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleColorChange = (e) => {
    // console.log("e :- ", e);

    this.props.autofill("selectedcolor", e.hex);
  };

  copyUrl = () => {
    this.props.showSuccess(LocaleStrings.copied);
  };

  downloadPdfF = (e, values) => {
    e.preventDefault();
    e.stopPropagation();
    // console.log("element :- ", e);
    let { appsession, eventDetails } = this.props;
    // console.log("session :- ", appsession);
    // console.log("values :- ", values);
    // console.log("eventDetails :- ", eventDetails);

    // this.setState({ QrDownloadLoading: true });
    // this.props.downloadSessionPdf(values.sessionid, (response) => {
    //   this.setState({ QrDownloadLoading: false });
    //   if (response.success) {
    //     var pdfurl = response.message.pdf;
    //     var filename = values.title;
    //     // console.log("filename", filename);
    //     // var uri = `${MAIN_URL}/pdfgenerate/sessionqr.pdf`;
    //     var uri = `${MAIN_URL}/${pdfurl}`;

    //     //this trick will generate a temp <a /> tag
    //     var link = document.createElement("a");
    //     link.href = uri;

    //     //set the visibility hidden so it will not effect on your web-layout
    //     link.style = "visibility:hidden";
    //     link.download = filename;
    //     link.target = "_blank";

    //     //this part will append the anchor tag and remove it after automatic click
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //   } else {
    //     this.props.showError(COMMON_FAIL_MESSAGE);
    //   }
    // });

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>{LocaleStrings.schedule_sessionqr_download_title}</h1>
            <p>{LocaleStrings.schedule_sessionqr_download_subtitle}</p>

            <div className="react-confirm-alert-button-group">
              <button
                type="button"
                onClick={() => {
                  this.setState({ QrDownloadLoading: true });
                  this.props.fetchSessionQr(
                    appsession,
                    { sessionid: values.sessionid, eventid: values.eventid },
                    (response) => {
                      // console.log("response", response);
                      onClose();
                      this.setState({ QrDownloadLoading: false });
                      if (response.success === 0) {
                        this.props.showError(COMMON_FAIL_MESSAGE);
                      } else {
                        let qrString = response.data.qr;

                        let themecolor = eventDetails.themecolor;
                        let eventname = eventDetails.eventname;
                        let imgData = `${BASE_IMAGES_URL}/${eventDetails.eventicon}?api_key=${appsession.apiKey}&session_token=${appsession.sessionToken}`;
                        let date = values.starttime
                          ? moment(values.starttime).format(
                              DISPLAY_LOCAL_DATE_FORMAT
                            )
                          : "";
                        let stime = values.starttime
                          ? moment(values.starttime).format("hh:mm A")
                          : "";
                        let etime = values.endtime
                          ? moment(values.endtime).format("hh:mm A")
                          : "";

                        const doc = new jsPDF("p", "pt", [8.3 * 72, 11.7 * 72]);
                        let getPageWidth =
                          doc.internal.pageSize.width ||
                          doc.internal.pageSize.getWidth();

                        doc.setFillColor(`${themecolor}`);
                        doc.rect(0, 0, 8.3 * 72, 66, "F");

                        doc.setFontSize(20);
                        doc.setFont(`Helvetica`, `normal`, `400`);
                        doc.setTextColor(`#fff`);
                        doc.text(`Session Check-in`, 37, 20 + 20);

                        let titleFont = values.title.length < 86 ? 26 : 24;

                        doc.setFontSize(titleFont);
                        doc.setFont(`Helvetica`, `normal`, `700`);
                        doc.setTextColor(`#000000`);
                        doc.text(`${values.title}`, 37, 80 + titleFont, {
                          maxWidth: getPageWidth - 70,
                        });

                        doc.setFontSize(17);
                        doc.setFont(`Helvetica`, `normal`, `400`);
                        doc.setTextColor(`#000000`);
                        doc.text(`Date  :  ${date}`, 37, 170 + 17);

                        doc.setFontSize(17);
                        doc.setFont(`Helvetica`, `normal`, `400`);
                        doc.setTextColor(`#000000`);
                        doc.text(`Time  :  ${stime} - ${etime}`, 37, 196 + 17);

                        doc.setFillColor(`#000000`);
                        doc.roundedRect(100, 249, 395, 437, 10, 10, "F");

                        doc.addImage(qrString, "JPEG", 110, 259, 375, 347);

                        doc.setFontSize(36);
                        doc.setFont(`Helvetica`, `normal`, `400`);
                        doc.setTextColor(`#fff`);
                        doc.text(`Scan Me`, 225, 620 + 36);

                        doc.addImage(imgData, "JPEG", 274, 708, 50, 50);

                        doc.setFontSize(17);
                        doc.setFont(`Helvetica`, `normal`, `400`);
                        doc.setTextColor(`#000000`);
                        doc.text(`${eventname}`, getPageWidth / 2, 760 + 17, {
                          align: "center",
                          maxWidth: getPageWidth,
                        });

                        doc.save(`${values.title}.pdf`);
                      }
                    }
                  );
                }}
              >
                {LocaleStrings.button_ok}
              </button>
              <button onClick={onClose}>{LocaleStrings.button_cancel}</button>
            </div>
          </div>
        );
      },
    });
  };

  handleAssociateSpeakers = (e, index) => {
    let selected = e.target.value !== "" ? parseInt(e.target.value) : "";
    let { sessionAssociatedSpeakers } = this.props;

    // console.log("selected :- ", selected);
    // console.log("index :- ", index);
    // console.log(
    //   "sessionAssociatedSpeakers in method :- ",
    //   sessionAssociatedSpeakers
    // );

    // Dont remove this code [Its to update the dom]
    this.setState({ update: !this.state.update });

    if (!_.includes(sessionAssociatedSpeakers, selected) || selected === "") {
      sessionAssociatedSpeakers[index] = selected;
      // console.log(
      //   "sessionAssociatedSpeakers new :- ",
      //   sessionAssociatedSpeakers
      // );

      this.props.updateSpeakerAssociate(sessionAssociatedSpeakers);
    }
  };

  deleteAssociateSpeakers = (index) => {
    let { sessionAssociatedSpeakers } = this.props;

    // console.log("index :- ", index);
    // console.log("sessionAssociatedSpeakers :- ", sessionAssociatedSpeakers);

    // Dont remove this code [Its to update the dom]
    this.setState({ update: !this.state.update });

    sessionAssociatedSpeakers.splice(index, 1);

    // console.log("sessionAssociatedSpeakers new :- ", sessionAssociatedSpeakers);

    this.props.updateSpeakerAssociate(sessionAssociatedSpeakers);
    // }
  };

  renderCustomSelect = (field) => {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    var showAddTrack = field.opts.length === 0;
    var fieldcss = "form-control dropdown-height-border";
    if (showAddTrack) {
      fieldcss = "form-control dropdown-height-border w-70";
    }
    return (
      <div className={divClassName}>
        <label className="">
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        {/* <div className="col-sm-9 col-sm-offset-0"> */}
        <select className={fieldcss} {...field.input}>
          <option value="" key={field.label}>
            {field.placeholder}
          </option>
          {field.opts.map((object, index) => {
            return (
              <option key={index} value={object.value}>
                {object.name}
              </option>
            );
          })}
        </select>
        {showAddTrack ? (
          <button
            className="btn btn-custom-blue pull-right"
            style={{ marginTop: -40 }}
            onClick={field.newTrackCallback}
          >
            {" "}
            <i className="fa fa-plus i-custom-m" aria-hidden="true" />{" "}
            {LocaleStrings.schedule_addtrack}{" "}
          </button>
        ) : (
          ""
        )}
        <div className="text-help label-text-help">
          {field.meta.touched ? field.meta.error : ""}
        </div>
        {/* </div> */}
      </div>
    );
  };

  addMoreSpeaker = (e) => {
    var additionalSpeakers = this.state.additionalSpeakers;
    additionalSpeakers.push({});
    this.setState({ ...this.state, additionalSpeakers });
  };

  renderAdditionalSpeakers = ({
    fields,
    speakers,
    sessionAssociatedSpeakers,
    deleteAssociate,
  }) => {
    return (
      <div>
        {fields.map((speaker, index) => {
          let indx = index + 1;

          // this below code is used to remove already used speaker from another speaker select field
          var speakersOpt = [];
          if (sessionAssociatedSpeakers.length > indx) {
            let match1 = _.filter(this.props.speakers, (o) => {
              return o.value === sessionAssociatedSpeakers[indx];
            });
            if (match1.length > 0) {
              speakersOpt.push(match1[0]);
            }
          }
          this.props.speakers.map((o) => {
            let spkid = parseInt(o.value);
            if (!_.includes(sessionAssociatedSpeakers, spkid)) {
              speakersOpt.push(o);
            }
          });
          // this above code is used to remove already used speaker from another speaker select field

          return (
            <Field
              name={`${speaker}.speakerid`}
              label={
                DEVELOPMENT_TYPE === "koachify"
                  ? "Choose Instructor"
                  : "Choose Speaker"
              }
              type="select"
              component={this.renderSelectWithDelete}
              mandatory="false"
              placeholder={
                DEVELOPMENT_TYPE === "koachify"
                  ? "Select Instructor"
                  : "Select Speaker"
              }
              opts={speakersOpt}
              key={`KEY-${index}`}
              deleteaction={() => {
                fields.remove(index);
                deleteAssociate(indx);

                // if(this.props.toEdit){
                //   this.props.deleteAdditionalSpeaker(speakers[index],this.props.selectedScheduleDate.scheduledateid,this.props.appsession)
                // }
              }}
              // onChange={(e) => {
              //   // if(this.props.toEdit){
              //   //     var updatedSpeaker=speakers[index];
              //   //     if(updatedSpeaker){
              //   //       updatedSpeaker={...updatedSpeaker,speakerid:e.target.value};
              //   //       this.props.updateAdditionalSpeaker(updatedSpeaker,this.props.selectedScheduleDate.scheduledateid,this.props.appsession);
              //   //     }else{
              //   //       var speaker={speakerid:e.target.value,eventid:this.props.appsession.eventid,sessionid:this.props.session.sessionid};
              //   //       this.props.addAdditionalSpeaker(speaker,this.props.selectedScheduleDate.scheduledateid,this.props.appsession);
              //   //     }
              //   // }
              // }}
              onChange={(e) => this.handleAssociateSpeakers(e, indx)}
            />
          );
        })}
        <div className="form-group">
          {/* <div className="col-sm-3">&nbsp;</div>
      <div className="col-sm-9 col-sm-offset-0"> */}
          <Button
            bsStyle=""
            className="btn btn-custom-blue"
            type="button"
            onClick={() => fields.push({})}
          >
            {DEVELOPMENT_TYPE === "koachify"
              ? "Link More Instructor"
              : "Link More Speaker"}
          </Button>
          {/* </div> */}
        </div>
      </div>
    );
  };

  renderCustomeFieldText(field) {
    var divClassName = `${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;

    return (
      <div className={divClassName}>
        <input
          {...field.input}
          className="form-control"
          type={field.type}
          placeholder={field.placeholder}
          disabled={field.disabled}
        />
        <div className="text-help label-text-help">
          {field.meta.touched ? field.meta.error : ""}
        </div>
      </div>
    );
  }

  renderCustomeSessionVideoFieldText(field) {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;

    return (
      <div className={divClassName}>
        <input
          className="form-control"
          type={field.type}
          placeholder={field.placeholder}
          {...field.input}
        />
        <div className="text-help label-text-help">
          {field.meta.touched ? field.meta.error : ""}
        </div>
      </div>
    );
  }

  renderToggleFieldCheckbox(field) {
    return (
      <div className="center-item">
        <label className="control-label-top">{field.label}</label>

        <label className="switch-button-container">
          <input type={field.type} {...field.input} />
          <span className="switch-slider switch-round "></span>
        </label>
      </div>
    );
  }

  renderPriceField = (field) => {
    var { labelposition } = field;
    var { settingData } = this.props;
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }
    return (
      <div className={divClassName}>
        {field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : null}
        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            maxLength={field.maxlength ? field.maxlength : ""}
            style={{ paddingLeft: 61 }}
          />

          <div className="currency-inside-inputbox">
            {settingData.resource[0].currency}
          </div>

          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  };

  render() {
    var {
      dates,
      appsession,
      handleSubmit,
      invalid,
      dirty,
      valid,
      pristine,
      submitting,
      speakers,
      tracks,
      supportingspeakers,
      toEdit,
      initialValues,
      ticketList,
      userCategoryList,
      eventDetails,
      selectedScheduleDate,
      forEditLoad,
      sessionAssociatedSpeakers,
      sessionPrivateUsersModal,
      isrsvp,
      actionAppModules,
    } = this.props;
    var {
      privateSessionUsers,
      privateSessionUsersUpdated,
      rsvpSessionUsers,
      rsvpSessionUsersUpdated,
      hideCapacityInputBox,
      isChangedCapacity,
      isFileChanged,
      expendAdditionalSetting,
      imagePreviewUrl,
      hideSessionMainVideo,
      isChangedEventifymeet,
      isChangedrsvp,
      displayColorPicker,
      loadingUserModalButton,
    } = this.state;
    var edit = toEdit;
    var tickets = [];
    var showORhideTicket = "hide";
    var showORhideUsers = "hide";
    var allSelectedUsers = [];
    var disableCapacityField = false;
    var allSelectedRSVPUsers = [];
    // var disabled = !((dirty && valid) || (edit && pristine));
    // var disabled = (pristine || invalid || submitting);
    var disabled = true;
    // console.log('pristine: - ', pristine);
    // console.log('invalid: - ', invalid);
    // console.log('submitting: - ', submitting);
    // console.log("edit: - ", edit);
    // console.log("forEditLoad: - ", forEditLoad);
    // console.log("initialValues: - ", initialValues);
    // console.log("dates: - ", dates);
    // console.log("selectedScheduleDate: - ", selectedScheduleDate);
    var monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];

    let tracksForSelectedDate =
      selectedScheduleDate.ScheduleDateToScheduletracks
        ? selectedScheduleDate.ScheduleDateToScheduletracks
        : [];
    // console.log("tracksForSelectedDate :- ", tracksForSelectedDate);

    // Check for selected date track required or not
    let checkTrackStatus = _.filter(tracksForSelectedDate, (o) => {
      return o.trackname === "##NOTRACK##";
    });

    var styles = reactCSS({
      default: {
        color: {
          width: "40px",
          height: "20px",
          border: "none",
          display: "flex",
          alignItems: "center",
        },
        swatch: {
          padding: "9px",
          background: "#fff",
          borderRadius: "5px",
          boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
          display: "inline-block",
          cursor: "pointer",
          margin: "0px 5px 0px 0px",
        },
        popover: {
          position: "absolute",
          zIndex: "2",
          boxShadow: "0 50px 60px 0 rgba(0,0,0,.1)",
        },
        cover: {
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px",
        },
      },
    });

    var scheduleDates = [];
    _.forEach(dates, function (date) {
      var scheduledate = `${date.scheduledate} 00:00:00`;

      // Works for safari and chrome both
      var now = parse(
        moment(scheduledate).format("DD-MM-YYYY HH:mm:ss"),
        "dd-MM-yyyy HH:mm:ss",
        new Date()
      );

      var strDate = now.getDate() + " " + monthNames[now.getMonth()];
      var obj = { name: strDate, value: date.scheduledateid };

      scheduleDates.push(obj);
    });

    var colorsArr = [];
    if (this.props.sessionColors && this.props.sessionColors.length > 0) {
      colorsArr = _.map(this.props.sessionColors, "backgroundcolor");
    }

    var sendpushOpts = [];
    _.forEach(this.props.sendPushTimes, function (value) {
      var obj = {
        name: value.name,
        value: value.value,
        // value: value.value,
      };

      sendpushOpts.push(obj);
    });
    var checkintypesOpts = [];

    _.forEach(this.props.checkinType, function (value) {
      var obj = {
        name: value.name,
        value: value.value,
        // value: value.value,
      };

      checkintypesOpts.push(obj);
    });

    if (edit && (privateSessionUsersUpdated || rsvpSessionUsersUpdated)) {
      disabled = false;
    } else if (edit && isFileChanged == true) {
      disabled = false;
    } else if (
      pristine === false &&
      invalid === false &&
      submitting === false
    ) {
      disabled = false;
    }

    let tempImage = "";
    if (edit) {
      if (initialValues.coverimage) {
        tempImage = `${BASE_IMAGES_URL}/${initialValues.coverimage}?api_key=${appsession.apiKey}&session_token=${appsession.sessionToken}`;
      }
    }

    // Private users
    if (privateSessionUsersUpdated) {
      allSelectedUsers = privateSessionUsers;
    } else {
      if (initialValues.selectedAppusers) {
        allSelectedUsers = initialValues.selectedAppusers;
      }
    }

    // Rsvp users
    if (rsvpSessionUsersUpdated) {
      allSelectedRSVPUsers = rsvpSessionUsers;
    } else {
      if (initialValues.selectedRSVPAppusers) {
        allSelectedRSVPUsers = initialValues.selectedRSVPAppusers;
      }
    }

    if (imagePreviewUrl == "") {
      imagePreviewUrl = tempImage;
    } else if (imagePreviewUrl == "removed") {
      imagePreviewUrl = "";
    }

    if (ticketList) {
      var today = moment().format(DATE_FORMAT_WITH_TIME);
      ticketList.forEach((item, index) => {
        var ticketDatetime = moment
          .utc(item.saleenddate)
          .local()
          .format(DATE_FORMAT_WITH_TIME);
        var validDate = moment(ticketDatetime).isAfter(today, "hours");
        var isattendee = false;
        var ticketCategory = _.filter(userCategoryList.data, (obj) => {
          return obj.id == item.usercategory;
        });

        if (
          (ticketCategory.length > 0 &&
            (ticketCategory[0]["type"] == "attendee" ||
              ticketCategory[0]["type"] == "speaker")) ||
          item.type === "addon"
        ) {
          isattendee = true;
        }

        // console.log("validDate : - ", validDate);
        // console.log("today : - ", today);
        // console.log("ticketDatetime : - ", ticketDatetime);
        // console.log("ticket : - ", item.ticketname);
        // console.log("=========================================");

        if (
          edit &&
          initialValues &&
          (initialValues.sessiontype == "additional" ||
            initialValues.sessiontype == "addprivate") &&
          initialValues.ticketassociated
        ) {
          let associated = initialValues.ticketassociated.split(",");

          if (associated.indexOf(item.id.toString()) >= 0) {
            var obj = {
              label: `${item.ticketname}`,
              value: item.id.toString(),
            };
            tickets.push(obj);
          } else if (
            item.status != "disabled" &&
            validDate &&
            isattendee == true
          ) {
            var obj = {
              label: `${item.ticketname}`,
              value: item.id.toString(),
            };
            tickets.push(obj);
          }
        } else {
          if (item.status != "disabled" && validDate && isattendee == true) {
            var obj = {
              label: `${item.ticketname}`,
              value: item.id.toString(),
            };
            tickets.push(obj);
          }
        }
      });
    }

    // Related states are used, coz we are not getting the initial value at the time of edit.
    if (this.sessionTypeAdded === true) {
      if (
        this.sessionType === "additional" ||
        this.sessionType === "addprivate"
      ) {
        showORhideTicket = "show";
      }
      if (this.sessionType === "private" || this.sessionType === "rsvp") {
        showORhideUsers = "show";
      }
    } else {
      if (
        initialValues.sessiontype === "additional" ||
        initialValues.sessiontype === "addprivate"
      ) {
        showORhideTicket = "show";
      }
      if (
        initialValues.sessiontype === "private" ||
        initialValues.sessiontype === "rsvp"
      ) {
        showORhideUsers = "show";
      }
    }

    // Related states are used, coz we are not getting the initila value at the time of edit.
    if (isChangedCapacity === true) {
      if (hideCapacityInputBox) {
        disableCapacityField = true;
      }
    } else {
      if (initialValues.capacity == "") {
        disableCapacityField = true;
      }
    }

    let step1active = "";
    let step1 = "fa fa-chevron-circle-down";
    if (expendAdditionalSetting === true) {
      step1active = "activeup";
      step1 = "fa fa-chevron-circle-up";
    }

    let showEventifyMeet = "hide";
    if (
      eventDetails &&
      eventDetails.clients_by_clientidfk &&
      eventDetails.clients_by_clientidfk.eventifyframe
    ) {
      showEventifyMeet = "show";
    }

    let matchPoll = _.filter(actionAppModules, (o) => {
      return o.bsClass === "polls";
    });
    let pollActive =
      matchPoll.length > 0 && matchPoll[0].isenabled ? true : false;

    let seocode =
      eventDetails && eventDetails.seocode
        ? eventDetails.seocode
        : "not-found-seocode";
    let liveQA =
      toEdit && pollActive
        ? `https://${seocode}.${DOMAIN_NAME}/o/#/live-qa/${initialValues.sessionid}`
        : "";
    let livePoll =
      toEdit && pollActive
        ? `https://${seocode}.${DOMAIN_NAME}/o/#/live-poll/${initialValues.sessionid}`
        : "";

    if (
      !isChangedEventifymeet &&
      initialValues &&
      initialValues.iseventifyframe
    ) {
      hideSessionMainVideo = true;
    }

    let mainvideorestrict = "hide";
    let mainvideo = "show";
    if (hideSessionMainVideo) {
      mainvideo = "hide";
      mainvideorestrict = "show";
    }

    // this below code is used to remove already used speaker from another speaker select field
    var speakersOpt = [];
    if (sessionAssociatedSpeakers.length > 0) {
      let match1 = _.filter(speakers, (o) => {
        return o.value === sessionAssociatedSpeakers[0];
      });
      if (match1.length > 0) {
        speakersOpt.push(match1[0]);
      }
    }
    speakers.map((o) => {
      let spkid = parseInt(o.value);
      if (!_.includes(sessionAssociatedSpeakers, spkid)) {
        speakersOpt.push(o);
      }
    });
    // this above code is used to remove already used speaker from another speaker select field

    // console.log("eventDetails: - ", eventDetails);
    // console.log("showEventifyMeet: - ", showEventifyMeet);
    // console.log("hideSessionMainVideo: - ", hideSessionMainVideo);
    // console.log("this.props.sessionColors : - ", this.props.sessionColors);
    // console.log("initialVals : - ", initialValues);
    // console.log("allSelectedUsers : - ", allSelectedUsers);
    // console.log("allSelectedRSVPUsers : - ", allSelectedRSVPUsers);
    // console.log("isrsvp : - ", isrsvp);

    return (
      <div>
        <Button
          className="btn-custom-blue schedule-add-button"
          style={{ marginLeft: 0 }}
          bsStyle=""
          onClick={this.open}
        >
          <img
            style={{ paddingRight: 10 }}
            src="../../style/images/header-icons/plus.png"
          ></img>
          {LocaleStrings.button_new_session}
        </Button>
        <div>
          <Modal
            className="modal-container"
            show={this.props.showModal === true ? true : false}
            onHide={this.close}
            animation={true}
            keyboard={false}
            backdrop="static"
            dialogClassName="newSessionModal"
            enforceFocus={false}
          >
            <form
              className="appuser-form"
              onSubmit={handleSubmit(this.onFormSubmit)}
            >
              <Modal.Header>
                <div className="import-modal-title">
                  {edit
                    ? LocaleStrings.schedule_edit_modal_title
                    : LocaleStrings.schedule_add_modal_title}
                </div>
                <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.close()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button>
              </Modal.Header>
              {edit && forEditLoad ? (
                <Modal.Body>
                  <div className="loader-container min-vh-100">
                    <Loader />
                  </div>
                </Modal.Body>
              ) : (
                <Modal.Body>
                  {DEVELOPMENT_TYPE === "koachify" ? (
                    <div className="row form-group">
                      <div className="col-md-8">
                        <label className="control-label-top">
                          {LocaleStrings.schedule_form_liveclass_banner}
                        </label>
                        <ImageCropper
                          displaySize={{ width: 540, height: 270 }} // For image display style
                          requiredSize={{ width: 600, height: 300 }} // For image size required validation
                          cropperSize={{ width: 440, height: 220 }} // Cropper display size. Note its add 50px for padding
                          marginBottom={25}
                          onImageSave={this.onImageSave}
                          onImageChange={this.onImageChange}
                          imagepath={imagePreviewUrl}
                          imageType="jpg"
                          className="drop-zone-area-custom-image"
                          insideImage="../../style/images/dummy-image-fill@3x.png"
                          insideImageStyle={{
                            width: 36,
                            height: 36,
                          }}
                          insideText="Drag and Drop or Click here to upload image. Image size must be 600x300 px."
                        />
                      </div>
                    </div>
                  ) : (
                    <>
                      <Field
                        name="scheduledate"
                        label={LocaleStrings.schedule_form_label_sessiondate}
                        mandatory="true"
                        component={this.renderSelect}
                        opts={scheduleDates}
                        onChange={this.handleScheduleDate}
                        labelposition={LABEL_POSITION_TOP}
                      />

                      {checkTrackStatus.length > 0 ? (
                        ""
                      ) : (
                        <Field
                          name="scheduletrackid"
                          label={LocaleStrings.schedule_form_label_track}
                          placeholder={LocaleStrings.schedule_form_ph_track}
                          mandatory="true"
                          component={this.renderCustomSelect}
                          opts={tracks}
                          newTrackCallback={
                            this.addNewTrackForSessionWithNoCurrentTrack
                          }
                        />
                      )}
                    </>
                  )}
                  <div className="row">
                    <div className="col-md-6">
                      <Field
                        name="title"
                        label={LocaleStrings.schedule_form_label_title}
                        placeholder={LocaleStrings.schedule_form_ph_title}
                        type="text"
                        mandatory="true"
                        component={this.renderFieldText}
                        labelposition={LABEL_POSITION_TOP}
                        maxlength={MAXLENOBJ.title ? MAXLENOBJ.title : ""}
                        onChange={this.handleSessionTitle}
                      />
                    </div>
                    <div className="col-md-6">
                      {DEVELOPMENT_TYPE === "koachify" ? (
                        ""
                      ) : (
                        <Field
                          name="location"
                          label={LocaleStrings.schedule_label_location}
                          placeholder={
                            LocaleStrings.schedule_placeholder_location
                          }
                          type="text"
                          mandatory="false"
                          component={this.renderFieldText}
                          labelposition={LABEL_POSITION_TOP}
                          maxlength={
                            MAXLENOBJ.location ? MAXLENOBJ.location : ""
                          }
                        />
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <Field
                        name="starttime"
                        label={LocaleStrings.schedule_label_starttime}
                        placeholder={
                          LocaleStrings.schedule_placeholder_starttime
                        }
                        mandatory="true"
                        component={this.renderTimePicker}
                        selectedDate={
                          selectedScheduleDate &&
                          selectedScheduleDate.scheduledate
                        }
                        selected={null}
                      />
                    </div>
                    <div className="col-md-6">
                      <Field
                        name="endtime"
                        label={LocaleStrings.schedule_label_endtime}
                        placeholder={LocaleStrings.schedule_placeholder_endtime}
                        mandatory="true"
                        component={this.renderTimePicker}
                        selectedDate={
                          selectedScheduleDate &&
                          selectedScheduleDate.scheduledate
                        }
                        selected={null}
                      />
                    </div>
                  </div>

                  <Field
                    name="checkintype"
                    label={LocaleStrings.schedule_form_label_checkintype}
                    mandatory="false"
                    component={this.renderSelect}
                    opts={checkintypesOpts}
                    labelposition={LABEL_POSITION_TOP}
                  />

                  <Field
                    name="selectedcolor"
                    label={LocaleStrings.schedule_form_label_color}
                    placeholder={LocaleStrings.schedule_form_ph_color}
                    type="text"
                    mandatory="true"
                    component={this.renderCompactColorPickerField}
                    labelposition={LABEL_POSITION_TOP}
                    styles={styles}
                    onClick={this.handlePickerClick.bind(this)}
                    colorsArr={colorsArr}
                    displayColorPicker={displayColorPicker}
                    onChangeComplete={this.handleColorChange.bind(this)}
                    handlePickerClose={this.handlePickerClose.bind(this)}
                  />

                  <InterestForms
                    initialValues={this.props.initialValues}
                    {...this.props}
                  />

                  <Field
                    name="speakerid"
                    label={LocaleStrings.schedule_form_label_speaker}
                    placeholder={LocaleStrings.schedule_form_ph_speaker}
                    mandatory="false"
                    component={this.renderSelect}
                    opts={speakersOpt}
                    labelposition={LABEL_POSITION_TOP}
                    onChange={(e) => this.handleAssociateSpeakers(e, 0)}
                  />
                  {speakers.length > 0 ? (
                    <FieldArray
                      name="additionalspeakers"
                      component={this.renderAdditionalSpeakers}
                      props={{
                        speakers: supportingspeakers,
                        sessionAssociatedSpeakers: sessionAssociatedSpeakers,
                        deleteAssociate: this.deleteAssociateSpeakers,
                      }}
                    />
                  ) : (
                    <div className="form-group interest-subtitle-info">
                      {LocaleStrings.schedule_form_text_speaker_related}
                    </div>
                  )}

                  <Field
                    name="description"
                    label={LocaleStrings.schedule_form_label_description}
                    placeholder={LocaleStrings.schedule_form_ph_description}
                    mandatory="false"
                    component={this.renderFieldTextarea}
                    labelposition={LABEL_POSITION_TOP}
                    maxlength={
                      MAXLENOBJ.description ? MAXLENOBJ.description : ""
                    }
                  />

                  {DEVELOPMENT_TYPE === "koachify" ? (
                    <div className="row">
                      <div className="col-md-12">
                        <label className="control-label-top">
                          {LocaleStrings.schedule_form_label_main_video}
                        </label>
                        <p className="textext-custom-theme">
                          <span className="text-custom-danger"> * </span>
                          {LocaleStrings.schedule_form_note_loggedinuser}
                        </p>
                      </div>

                      <div className="row m-0">
                        <div className="col-md-8">
                          <Field
                            name="videolink"
                            placeholder={
                              LocaleStrings.schedule_form_ph_main_video
                            }
                            type="text"
                            component={this.renderCustomeSessionVideoFieldText}
                          />
                        </div>

                        <div className="col-md-4">
                          <Field
                            name="restrictstarttime1"
                            label={
                              LocaleStrings.schedule_form_label_restricttime
                            }
                            component={this.renderToggleFieldCheckbox}
                            type="checkbox"
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="text-right mb-15"
                      data-data_id="expendAdditionalSetting"
                    >
                      <h4 className="">
                        {LocaleStrings.schedule_form_text_additional_settings}{" "}
                        <i
                          className={step1active + " " + step1}
                          aria-hidden="false"
                          onClick={() =>
                            this.toggleStep("expendAdditionalSetting")
                          }
                          style={{ cursor: "pointer" }}
                        ></i>
                      </h4>
                    </div>
                  )}

                  {expendAdditionalSetting === true ? (
                    <div>
                      <div className="form-group">
                        <label className="control-label-top">
                          {LocaleStrings.schedule_form_label_session_type}
                          <span className="label-mandatory">*</span>
                        </label>
                        <Field
                          name="sessiontype"
                          label={
                            LocaleStrings.schedule_form_label_session_type_option1
                          }
                          value="general"
                          type="radio"
                          component={this.renderFieldRadio}
                          onChange={this.handleSessionType}
                        />
                        <Field
                          name="sessiontype"
                          label={
                            LocaleStrings.schedule_form_label_session_type_option2
                          }
                          type="radio"
                          value="private"
                          component={this.renderFieldRadio}
                          onChange={this.handleSessionType}
                        />
                        <Field
                          name="sessiontype"
                          label={
                            LocaleStrings.schedule_form_label_session_type_option3
                          }
                          component={this.renderFieldRadio}
                          type="radio"
                          value="additional"
                          onChange={this.handleSessionType}
                        />
                        <Field
                          name="sessiontype"
                          label={
                            LocaleStrings.schedule_form_label_session_type_option4
                          }
                          component={this.renderFieldRadio}
                          type="radio"
                          value="addprivate"
                          onChange={this.handleSessionType}
                        />
                      </div>

                      <div className={showORhideTicket}>
                        <div className="row form-group">
                          {DEVELOPMENT_TYPE === "koachify" ? (
                            <div className="col-md-6">
                              <Field
                                name="sessionprice"
                                label={LocaleStrings.schedule_form_label_fee}
                                placeholder={LocaleStrings.schedule_form_ph_fee}
                                type="text"
                                mandatory="false"
                                component={this.renderPriceField}
                                labelposition={LABEL_POSITION_TOP}
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          <div
                            className={`${
                              DEVELOPMENT_TYPE === "koachify"
                                ? "col-md-6"
                                : "col-md-12"
                            }`}
                          >
                            <label className="control-label-top">
                              {LocaleStrings.schedule_form_label_allowreassign}
                            </label>
                            <Field
                              name="isreassign"
                              label={
                                LocaleStrings.schedule_form_label_allowreassign_text
                              }
                              type="checkbox"
                              component={this.renderFieldCheckbox}
                            />
                          </div>
                        </div>

                        <Field
                          name="ticketassociated"
                          label={LocaleStrings.schedule_form_label_association}
                          placeholder={
                            LocaleStrings.schedule_form_ph_association
                          }
                          mandatory="false"
                          component={this.renderReactMultiSelectCheckboxes}
                          opts={tickets}
                          labelposition={LABEL_POSITION_TOP}
                        />
                      </div>

                      <div className="">
                        {/* <div className={showORhideUsers}> */}
                        <div className="form-group">
                          <Button
                            type="button"
                            className="btn-default"
                            style={{ marginRight: 5 }}
                            disabled={true}
                          >
                            <span className="schedule-user-selected">
                              {allSelectedUsers.length > 0
                                ? `${allSelectedUsers.length} ${LocaleStrings.users_selected}`
                                : `${allSelectedUsers.length} ${LocaleStrings.user_selected}`}
                            </span>
                          </Button>

                          <Button
                            bsStyle=""
                            className="btn btn-custom-blue"
                            onClick={() => this.openPrivateUserModal("private")}
                            loading={
                              loadingUserModalButton === "private"
                                ? true
                                : false
                            }
                          >
                            <i
                              className="fa fa-plus i-custom-m"
                              aria-hidden="true"
                            />
                            {LocaleStrings.button_view_manage_users}
                          </Button>
                        </div>
                      </div>

                      <div className="form-group">
                        <Field
                          name="rsvp"
                          label={LocaleStrings.schedule_form_label_rsvp}
                          component={this.renderFieldCheckbox}
                          type="checkbox"
                        />
                      </div>

                      {isrsvp === true ? (
                        <div className="form-group">
                          <label className="control-label-top">
                            {LocaleStrings.schedule_form_label_capacity}
                            <span className="label-mandatory">*</span>
                          </label>

                          <Field
                            name="unlimitedcapacity"
                            label={LocaleStrings.schedule_form_label_unlimited}
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.handleCapacity}
                          />
                          <Field
                            name="capacity"
                            placeholder={
                              LocaleStrings.schedule_form_ph_capacity
                            }
                            type="text"
                            mandatory="false"
                            component={this.renderCustomeFieldText}
                            disabled={disableCapacityField}
                          />

                          <div className="mt-3">
                            <Button
                              type="button"
                              className="btn-default"
                              style={{ marginRight: 5 }}
                              disabled={true}
                            >
                              <span className="schedule-user-selected">
                                {allSelectedRSVPUsers.length > 0
                                  ? `${allSelectedRSVPUsers.length} RSVP Users`
                                  : `${allSelectedRSVPUsers.length} RSVP User`}
                              </span>
                            </Button>

                            <Button
                              bsStyle=""
                              className="btn btn-custom-blue"
                              onClick={() => this.openPrivateUserModal("rsvp")}
                              loading={
                                loadingUserModalButton === "rsvp" ? true : false
                              }
                            >
                              <i
                                className="fa fa-plus i-custom-m"
                                aria-hidden="true"
                              />
                              {LocaleStrings.button_view_manage_users}
                            </Button>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {DEVELOPMENT_TYPE === "koachify" ? (
                        ""
                      ) : (
                        <div className="row">
                          <div className={`col-md-12 ${mainvideo}`}>
                            <label className={`control-label-top`}>
                              {LocaleStrings.schedule_form_label_main_video}
                            </label>
                            <p className="text-custom-theme">
                              <span className="text-custom-danger"> * </span>
                              {LocaleStrings.schedule_form_note_loggedinuser}
                            </p>
                          </div>

                          <div className={`row ${mainvideo}`}>
                            <div className="col-md-8">
                              <Field
                                name="videolink"
                                placeholder={
                                  LocaleStrings.schedule_form_ph_main_video
                                }
                                type="text"
                                component={
                                  this.renderCustomeSessionVideoFieldText
                                }
                              />
                            </div>

                            <div className="col-md-4">
                              <Field
                                name="restrictstarttime1"
                                label={
                                  LocaleStrings.schedule_form_label_restricttime
                                }
                                component={this.renderToggleFieldCheckbox}
                                type="checkbox"
                              />
                            </div>
                          </div>

                          <hr className={`hr-custom-general ${mainvideo}`} />

                          <div className="row">
                            <div className="col-md-12">
                              <label className="control-label-top">
                                {
                                  LocaleStrings.schedule_form_label_othervideo_links
                                }
                              </label>
                            </div>
                            <div className="col-md-8">
                              <Field
                                name="additionalvideo1"
                                placeholder={
                                  LocaleStrings.schedule_form_ph_othervideo_links
                                }
                                type="text"
                                component={
                                  this.renderCustomeSessionVideoFieldText
                                }
                              />
                            </div>

                            <div className="col-md-4  center-item">
                              <Field
                                name="restrictstarttime2"
                                label={
                                  LocaleStrings.schedule_form_label_restricttime
                                }
                                component={this.renderToggleFieldCheckbox}
                                type="checkbox"
                              />
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-8">
                              <Field
                                name="additionalvideo2"
                                placeholder={
                                  LocaleStrings.schedule_form_ph_othervideo_links
                                }
                                type="text"
                                component={
                                  this.renderCustomeSessionVideoFieldText
                                }
                              />
                            </div>

                            <div className="col-md-4">
                              <Field
                                name="restrictstarttime3"
                                label={
                                  LocaleStrings.schedule_form_label_restricttime
                                }
                                component={this.renderToggleFieldCheckbox}
                                type="checkbox"
                              />
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-8">
                              <Field
                                name="additionalvideo3"
                                placeholder={
                                  LocaleStrings.schedule_form_ph_othervideo_links
                                }
                                type="text"
                                component={
                                  this.renderCustomeSessionVideoFieldText
                                }
                              />
                            </div>

                            <div className="col-md-4">
                              <Field
                                name="restrictstarttime4"
                                label={
                                  LocaleStrings.schedule_form_label_restricttime
                                }
                                component={this.renderToggleFieldCheckbox}
                                type="checkbox"
                              />
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-8">
                              <Field
                                name="additionalvideo4"
                                placeholder={
                                  LocaleStrings.schedule_form_ph_othervideo_links
                                }
                                type="text"
                                component={
                                  this.renderCustomeSessionVideoFieldText
                                }
                              />
                            </div>

                            <div className="col-md-4">
                              <Field
                                name="restrictstarttime5"
                                label={
                                  LocaleStrings.schedule_form_label_restricttime
                                }
                                component={this.renderToggleFieldCheckbox}
                                type="checkbox"
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="">
                        <label className="control-label-top">
                          {LocaleStrings.schedule_form_label_file_upload}
                        </label>
                        <div>{this.otherFiles()}</div>
                      </div>

                      <Field
                        name="sendpush"
                        label={LocaleStrings.schedule_form_label_sendpush}
                        placeholder={LocaleStrings.schedule_form_ph_sendpush}
                        mandatory="false"
                        component={this.renderSelect}
                        opts={sendpushOpts}
                        labelposition={LABEL_POSITION_TOP}
                        onChange={this.handlesendpush}
                      />

                      <Field
                        name="pushmessage"
                        label={LocaleStrings.schedule_form_label_pushmessage}
                        placeholder={LocaleStrings.schedule_form_ph_pushmessage}
                        mandatory="false"
                        component={this.renderFieldTextarea}
                        maxlength={
                          MAXLENOBJ.pushmessage ? MAXLENOBJ.pushmessage : ""
                        }
                        labelposition={LABEL_POSITION_TOP}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </Modal.Body>
              )}
              <Modal.Footer className="justify-content-between">
                <div className="d-flex gap-2">
                  {liveQA !== "" ? (
                    <CopyToClipboard text={liveQA} onCopy={this.copyUrl}>
                      <Button
                        bsStyle=""
                        className="btn btn-custom-white"
                        type="button"
                      >
                        <i
                          className="fa fa-files-o i-custom-m"
                          aria-hidden="true"
                        />
                        {LocaleStrings.button_copy_qa_url}
                      </Button>
                    </CopyToClipboard>
                  ) : (
                    ""
                  )}

                  {livePoll !== "" ? (
                    <CopyToClipboard text={livePoll} onCopy={this.copyUrl}>
                      <Button
                        bsStyle=""
                        className="btn btn-custom-white"
                        type="button"
                      >
                        <i
                          className="fa fa-files-o i-custom-m"
                          aria-hidden="true"
                        />
                        {LocaleStrings.button_copy_poll_url}
                      </Button>
                    </CopyToClipboard>
                  ) : (
                    ""
                  )}

                  {toEdit &&
                  (initialValues.checkintype == "scanqr" ||
                    initialValues.checkintype == "bothside") ? (
                    <Button
                      bsStyle=""
                      className="btn btn-custom-white"
                      type="button"
                      loading={this.state.QrDownloadLoading}
                      onClick={(e) => this.downloadPdfF(e, initialValues)}
                    >
                      <i
                        className="fa fa-download i-custom-m"
                        aria-hidden="true"
                      />
                      {LocaleStrings.button_qr_download}
                    </Button>
                  ) : (
                    ""
                  )}
                </div>

                <div>
                  <Button
                    bsStyle=""
                    className="btn btn-custom-white"
                    type="button"
                    onClick={this.close}
                  >
                    {LocaleStrings.button_close}
                  </Button>

                  <Button
                    bsStyle=""
                    className="btn btn-custom-blue ml-10"
                    loading={this.state.loading}
                    type="submit"
                    disabled={disabled}
                  >
                    {LocaleStrings.button_save_changes}
                  </Button>
                </div>
              </Modal.Footer>
            </form>
          </Modal>
        </div>

        {sessionPrivateUsersModal.show ? (
          <SessionPrivateUserModal
            initialValues={this.props.initialValues}
            updateAccoicatedUsers={this.handleAccoicatedUsers}
            membersData={
              sessionPrivateUsersModal.type === "private"
                ? allSelectedUsers
                : allSelectedRSVPUsers
            }
            flag={"SESSION"}
          />
        ) : null}
      </div>
    );
  }
}

const selector = formValueSelector("AddSessionForm");

function mapStateToProps(state, ownProps) {
  var appUsers = state.scheduleData.payload.appuser_by_eventid;
  var forEditLoad = true;

  var dates = [];
  if (state.scheduleData.payload.scheduledates_by_eventid)
    var scheduledates =
      state.scheduleData.payload.scheduledates_by_eventid.filter(
        (date) => date.isactive
      );
  var sortArrAvailable = _.sortBy(scheduledates, "scheduledate", "asc");
  dates = sortArrAvailable;

  if (DEVELOPMENT_TYPE === "koachify") {
    dates = state.sessionWeekdays;
  }

  //scheduledate
  var toEdit = !isEmpty(state.sessionModal.session);
  if (
    state.sessionModal.session &&
    state.sessionModal.session.toaddwithtrackid === "1"
  ) {
    toEdit = false;
  }
  // console.log("state.sessionModal :- ", state.sessionModal);
  // console.log("state.selectedScheduleDate :- ", state.selectedScheduleDate);

  var initVals = {};
  var unlimitedcapacity = true;
  var capacity = "";

  if (!isEmpty(state.selectedScheduleDate)) {
    initVals.scheduledate = state.selectedScheduleDate.scheduledateid;
  }

  // console.log(
  //   "state.singleSessionAssociatedUsers :- ",
  //   state.singleSessionAssociatedUsers
  // );
  // console.log("state.singleSessionRSVPUsers :- ", state.singleSessionRSVPUsers);

  if (
    toEdit &&
    state.singleSessionAssociatedUsers &&
    state.singleSessionAssociatedUsers.data &&
    state.singleSessionRSVPUsers &&
    state.singleSessionRSVPUsers.data
  ) {
    forEditLoad = false; // This is used only for edit session as now we are fetching associated users at edit session time.
    initVals = { ...initVals, ...state.sessionModal.session };
    var sessionAssocUsers = [];
    var selectedAppusers = [];

    _.map(state.singleSessionAssociatedUsers.data, (item) => {
      var user = {
        ...item.appuser_by_appuserid,
        checked: true,
      };
      sessionAssocUsers.push(item);
      selectedAppusers.push(user);
    });

    var sessionAssocRSVPUsers = [];
    var selectedRSVPAppusers = [];
    _.map(state.singleSessionRSVPUsers.data, (item) => {
      var user = {
        ...item.appuser_by_appuserid,
        checked: true,
      };
      sessionAssocRSVPUsers.push(item);
      selectedRSVPAppusers.push(user);
    });

    if (initVals.capacity > 0) {
      unlimitedcapacity = false;
      capacity = initVals.capacity;
    }

    var { backgroundcolor } =
      state.sessionColors && state.sessionColors.payload
        ? state.sessionColors.payload.filter(
            (color) => color.colorid === initVals.colorid
          )[0]
        : { backgroundcolor: "#FDAFBD" };

    initVals = {
      ...initVals,
      selectedcolor: backgroundcolor,
      starttime: moment(initVals.starttime),
      endtime: moment(initVals.endtime),
      capacity: capacity,
      unlimitedcapacity: unlimitedcapacity,
      sessiontype: initVals.sessiontype,
      sessionAssocUsers: sessionAssocUsers,
      selectedAppusers: selectedAppusers,
      sessionAssocRSVPUsers: sessionAssocRSVPUsers,
      selectedRSVPAppusers: selectedRSVPAppusers,
      coverimagehidden: initVals.coverimage,
      starttimeold: initVals.starttime,
      endtimeold: initVals.endtime,
    };
  } else {
    var backgroundcolor =
      state.sessionModal &&
      state.sessionModal.otherdata &&
      state.sessionModal.otherdata.backgroundcolor
        ? state.sessionModal.otherdata.backgroundcolor
        : "#FDAFBD";

    initVals = {
      ...initVals,
      selectedcolor: backgroundcolor,
      speakerid: "0",
      capacity: capacity,
      sessiontype: "general",
      checkintype: "nocheckinneeded",
      unlimitedcapacity: unlimitedcapacity,
      selectedAppusers: [],
      selectedRSVPAppusers: [],
      isreassign: 1,
      restrictstarttime1: 0,
      restrictstarttime2: 0,
      restrictstarttime3: 0,
      restrictstarttime4: 0,
      restrictstarttime5: 0,
    };

    if (
      DEVELOPMENT_TYPE === "koachify" &&
      state.sessionDefaultTrack.length > 0 &&
      !toEdit
    ) {
      initVals.scheduletrackid = state.sessionDefaultTrack[0].scheduletrackid;
    }
  }

  var speakers = [];
  if (state.scheduleData && state.scheduleData.payload.speaker_by_eventid) {
    state.scheduleData.payload.speaker_by_eventid.map((speaker) => {
      speakers.push({
        name: `${speaker.firstname} ${speaker.lastname}`,
        value: speaker.speakerid,
      });
    });
  }

  var availableTracks = state.selectedScheduleDate.ScheduleDateToScheduletracks;
  var tracks = [];
  if (availableTracks) {
    if (availableTracks.length > 0 && !toEdit) {
      //If there are more than one track we need extra option to add session to all the tracks in add mode only
      // tracks.push({name:"Add Session for all Tracks",value:'-100'});  // This option is hide on 03_04_2020 by vinay, as it was not required too add same seeion to all tracks as per Hussain sir.
    }
    availableTracks.map((track) => {
      tracks.push({ name: track.trackname, value: track.scheduletrackid });
    });
  }

  var supportingspeakers = [];
  if (state.scheduleData.payload.speaker_by_eventid) {
    supportingspeakers =
      state.scheduleData.payload.sessionspeakers_by_eventid.filter(
        (sessionspeaker) =>
          sessionspeaker.sessionid === state.sessionModal.session.sessionid
      );
  }

  if (toEdit && supportingspeakers.length > 0) {
    initVals = { ...initVals, additionalspeakers: supportingspeakers };
  }
  if (!toEdit) {
    initVals = { ...initVals, checkintype: "nocheckinneeded" };
  }

  if (
    state.sessionModal.session &&
    state.sessionModal.session.toaddwithtrackid === "1"
  ) {
    initVals = {
      ...initVals,
      scheduletrackid: state.sessionModal.session.scheduletrackid,
    };
    toEdit = false;
  }
  var userInt = [];

  if (initVals.hasOwnProperty("tags") && !_.isEmpty(initVals.tags)) {
    if (typeof initVals.tags === "string") {
      var str = initVals.tags;
      var userInt = new Array();

      userInt = str.split(",");
    }
  }
  var result = userInt.map(function (x) {
    return parseInt(x);
  });
  initVals["tags"] = result;
  // console.log("initValsinitValsinitVals", initVals);

  var sessionAssociatedSpeakers = [];
  if (state.sessionAssociatedSpeakers.length > 0) {
    sessionAssociatedSpeakers = state.sessionAssociatedSpeakers;
  } else {
    if (initVals.speakerid > 0) {
      sessionAssociatedSpeakers.push(initVals.speakerid);
    }
    if (initVals.additionalspeakers && initVals.additionalspeakers.length > 0) {
      initVals.additionalspeakers.map((o) => {
        sessionAssociatedSpeakers.push(o.speakerid);
      });
    }
  }
  // console.log("initVals :- ", initVals);
  // console.log("sessionAssociatedSpeakers :- ", sessionAssociatedSpeakers);

  return {
    dates,
    appsession: state.session,
    showModal: state.sessionModal.status,
    session: state.sessionModal.session,
    toEdit,
    forEditLoad,
    initialValues: initVals,
    selectedScheduleDate: state.selectedScheduleDate,
    speakers,
    sessionColors: state.sessionColors.payload,
    tracks,
    supportingspeakers,
    ticketList: state.allTicketList.resource,
    sessionPrivateUsersModal: state.sessionPrivateUsersModal,
    sessionfilesList: state.sessionfilesList,
    eventDetails: state.userEventDetails,
    userCategoryList: state.userCategoryList,
    settingData: state.SettingData,
    interestList: state.interests,
    sendPushTimes: state.sendPushTimes,
    checkinType: state.checkinType,
    sessionAssociatedSpeakers,
    actionAppModules: state.actionAppModules,

    // form field values
    sessiontitle: selector(state, "title"),
    sendpush: selector(state, "sendpush"),
    pushmessage: selector(state, "pushmessage"),
    isrsvp: selector(state, "rsvp"),
  };
}

function validate(values, ownProps) {
  // console.log("values :- ", values);
  var selectedScheduleDate = ownProps.selectedScheduleDate;
  var errors = {};

  var starttime = values["starttime"];
  var endtime = values["endtime"];
  var capacity = values["capacity"];
  var unlimitedcapacity = values["unlimitedcapacity"];
  var sessiontype = values["sessiontype"];
  var ticketassociated = values["ticketassociated"];
  var sessionprice = values["sessionprice"];
  var res = null;

  var sendpush = values["sendpush"];
  var pushmessage = values["pushmessage"];

  if (
    ticketassociated &&
    ticketassociated != "" &&
    Array.isArray(ticketassociated) &&
    ticketassociated.length > 0
  ) {
    res = ticketassociated.join(",");
  } else if (
    ticketassociated &&
    ticketassociated != "" &&
    !Array.isArray(ticketassociated)
  ) {
    res = ticketassociated;
  } else {
    res = null;
  }

  var requiredFields = ["sessiontrackid", "title"];
  requiredFields.forEach((field) => {
    if (!values[field] || values[field].trim() === "") {
      errors[field] = LocaleStrings.required;
    }
  });

  if (!starttime || starttime == "") {
    errors.starttime = LocaleStrings.required;
  }
  if (!endtime || endtime == "") {
    errors.endtime = LocaleStrings.required;
  }
  if (starttime && endtime) {
    var startT =
      typeof starttime === "string"
        ? moment(`${selectedScheduleDate.scheduledate} ${starttime}`)
        : starttime;
    var endT =
      typeof endtime === "string"
        ? moment(`${selectedScheduleDate.scheduledate} ${endtime}`)
        : endtime;

    if (moment(endT).isSameOrBefore(startT)) {
      errors.endtime =
        LocaleStrings.schedule_form_validation_end_time_greater_start_time;
    }
  }

  if (unlimitedcapacity === false && capacity == "") {
    errors.capacity = "Required";
  }
  if (
    (capacity && isNaN(capacity) === true) ||
    (capacity && Number(capacity) <= 0)
  ) {
    errors.capacity = LocaleStrings.schedule_validation_capcity;
  }
  // if((!sendpush == null || !sendpush == undefined) && (pushmessage == null || pushmessage == undefined) ){
  //   console.log('2')
  //   errors.pushmessage = "Required";
  // }
  if (
    DEVELOPMENT_TYPE === "eventify" &&
    sessiontype &&
    (sessiontype === "additional" || sessiontype === "addprivate") &&
    !res
  ) {
    errors.ticketassociated =
      LocaleStrings.schedule_validation_ticketadditional;
  }
  if (
    sessiontype &&
    (sessiontype === "additional" || sessiontype === "addprivate") &&
    sessionprice &&
    (isNaN(sessionprice) || sessionprice < 0)
  ) {
    errors.sessionprice = LocaleStrings.schedule_validation_validfee;
  }

  if (values["title"] && MAXLENOBJ) {
    if (values["title"].length > MAXLENOBJ.title) {
      errors["title"] = LocaleStrings.max_characters_left + MAXLENOBJ.title;
    }
  }

  if (values["location"] && MAXLENOBJ) {
    if (values["location"].length > MAXLENOBJ.location) {
      errors["location"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.location;
    }
  }

  if (values["description"] && MAXLENOBJ) {
    if (values["description"].length > MAXLENOBJ.description) {
      errors["description"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.description;
    }
  }

  if (values["pushmessage"] && MAXLENOBJ) {
    if (values["pushmessage"].length > MAXLENOBJ.pushmessage) {
      errors["pushmessage"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.pushmessage;
    }
  }
  // console.log("errors :- ", errors);
  return errors;
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  addScheduleSession,
  addAdditionalSpeaker,
  updateAdditionalSpeaker,
  deleteAdditionalSpeaker,
  addAdditionalSpeakerAssociation,
  addMultipleScheduleSession,
  updateScheduleSession,
  openSessionModal,
  clearSingleSessionAssociatedUsers,
  clearSingleSessionRSVPUsers,
  openTrackModal,
  deleteAdditionalSpeakerBySession,
  fetchAndRefreshScheduleData,
  checkContentDashboardStatus,
  openPrivateSessionUserModal,
  addAssociatedUsers,
  updatePrivateAssociateUsers,
  addRsvpUsers,
  updateRSVPUsers,
  fetchUsersCategory,
  sortUserByCategory,
  updateSessionFiles,
  editDashboardUser,
  updateSpeakerAssociate,
  selectScheduleDate,
  downloadSessionPdf,
  fetchSessionQr,
})(
  reduxForm({
    form: "AddSessionForm",
    validate,
    enableReinitialize: true,
  })(AddTrackSession)
);

class InterestForms extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      userInterest: [],
    };
  }

  componentDidMount() {
    this.setState({ userInterest: this.props.initialValues.tags });
  }

  handleUserInterest = (item) => {
    var array = this.state.userInterest;
    // console.log('item :- ', item);

    if (_.includes(array, item.interestid)) {
      var filter = _.filter(array, function (n) {
        return n != item.interestid;
      });
      array = filter;
    } else {
      array = [...array, item.interestid];
    }

    this.setState({ userInterest: array });
    this.props.autofill(`tags`, array);
  };

  _renderInterests = () => {
    let { interestList } = this.props;
    let { userInterest } = this.state;
    // console.log("userInterest :- ", userInterest);
    // console.log("initialValues.userinterests :- ", this.props.initialValues);

    return _.map(interestList, (item, index) => {
      // console.log('_.includes(userInterest, item.interestid)',_.includes(userInterest, item.interestid))
      return (
        <div
          key={`int_key${index}`}
          className={`custom-text1-primary-normal ${
            _.includes(userInterest, item.interestid)
              ? "selected-interest"
              : "interests"
          }`}
          onClick={() => this.handleUserInterest(item)}
        >
          {item.interest}
          {_.includes(userInterest, item.interestid) ? (
            <span>
              &nbsp; <i className="fa fa-check" aria-hidden="true"></i>
            </span>
          ) : (
            ""
          )}
        </div>
      );
    });
  };

  render() {
    // console.log("this.props", this.props.passcodeEmail);
    return (
      <div className="row form-group">
        <div className="col-sm-12">
          <label className="control-label-top">
            {LocaleStrings.schedule_form_label_tags}
          </label>

          <div className="interest-section">{this._renderInterests()}</div>
          <Field
            name="tags"
            type="text"
            component={this.renderHiddenFieldText}
          />
        </div>
      </div>
    );
  }
}
